module.exports = function(bootstrap) {

    'use strict';
    bootstrap.directive('networkStatus', ["$q", "teamsite","$timeout", function($q, teamsite, $timeout) {

        return {
            restrict: 'A',
            replace: false,
            template: require('directives/networkStatus.html'),
            scope: {
                details: '=networkStatus',
                productId: '=?',

            },
            controller: ['$scope', '$state', 'modal', 'sessionData', function($scope, $state, modal, sessionData) {

                $q.all({
                    'id1': teamsite.get("PVD_SearchResults_NetworkTipHeading"),
                    'id2': teamsite.get("PVD_SearchResults_NetworkTip"),
                    'id3': teamsite.get("PVD_PLAN_MESSAGE")
                    // 'id3': teamsite.get("PVD_SearchResults_CheckPlanIconText")
                }).then(function(content){
                    $scope.tooltip_CheckNetworkHeading = content.id1;
                    $scope.tooltip_checkNetwork = content.id2;
                    $scope.checkNetworkIconText = content.id3;
                });

                if (sessionData && sessionData.appConfig && sessionData.appConfig.PROVIDER) {
                    $scope.PVD_MEDICARE_PRODUCT = sessionData.appConfig.PROVIDER.PVD_MEDICARE_PRODUCT ? sessionData.appConfig.PROVIDER.PVD_MEDICARE_PRODUCT : {booleanValue : true, overrideValue:"766,310,410"};
                    $scope.PVD_FUTURE_PROVIDERS = !!(sessionData.appConfig.PROVIDER.PVD_FUTURE_PROVIDERS && sessionData.appConfig.PROVIDER.PVD_FUTURE_PROVIDERS.booleanValue);
                }

                $scope.medicare = false;

                $scope.checkMedicareList = function () {
                    if($scope.PVD_MEDICARE_PRODUCT&& $scope.PVD_MEDICARE_PRODUCT.overrideValue) {
                        var productBlacklist = $scope.PVD_MEDICARE_PRODUCT.overrideValue.split(",");
                        for (var index=0,len=productBlacklist.length;index<len;++index) {
                            if(productBlacklist[index] ===  $scope.productId) {
                                $scope.medicare = true;
                            }
                        }
                    }
                    return $scope.medicare;
                };

                $scope.tooltip_upmc = "";

                if ($scope.details.upmc === "C") {
                    $scope.tooltip_upmc="<span>This doctor or facility may not be in your plan's network. Ask them to be sure. </span><span data-ng-show='$parent.hasMore()'><a style='color:#0071a9' data-ng-click='$parent.goToMore()'>See More</a></span>";
                } else if ($scope.details.upmc === "Y") {
                    $scope.tooltip_upmc="<span>This doctor or facility may not be in-network at all locations. Ask them to be sure. </span><span data-ng-show='$parent.hasMore()'><a style='color:#0071a9' data-ng-click='$parent.goToMore()'>See More</a></span>";
                }

                $scope.tooltip_inNetwork = "In your plan's network. Your out-of-pocket costs are generally lower when you get in-network care.";
                $scope.tooltip_outOfNetwork = "This doctor or facility may not be in-network at this time.";

                $scope.hasMore = function() {
                    if ($scope.details.upmc === "Y" || $scope.details.upmc === "C") {
                        return true;
                    }
                };
                $scope.setFocus = function() {
                    $scope.$emit('showPlan');
                    $timeout(function(){parent.setFocus()},300);

                };
                parent.setFocus = function(){
                    var planName = angular.element('div#planSelection input.search ' );
                    planName.focus();

                };

                $scope.goToMore = function() {
                   // modal.close();
                    if ($scope.details.upmc === "C") {
                        $state.go("upmc", { page:"UPMC" });
                    }if ($scope.details.upmc === "Y") {
                        $state.go("upmc", { page:"UPMC2" });
                    }
                };
            }]
        };
    }]);
};